import React from 'react'
import { useTranslation } from 'react-i18next'
import { DAY_OPTIONS, MONTH_OPTIONS, YEAR_OPTIONS } from 'constants/date-options'
import SelectWTN from './SelectWTN'
import styles from './dateSelectGroup.module.scss'
import formStyles from './styles/forms.module.scss'
import { ErrorMessage, useFormikContext } from 'formik'

interface Props {
  valueKeys: {
    fullDate: string
    day: string
    month: string
    year: string
  }
  isDisabled?: boolean
}

const DateSelectGroup = ({ valueKeys, isDisabled = false }: Props) => {
  const { t } = useTranslation('strCommonUI')
  const { values, setFieldValue } = useFormikContext<{}>()
  return (
    <>
      <fieldset
        id={valueKeys.fullDate}
        className={styles.dobGroup}
        data-formik-error={valueKeys.fullDate}
      >
        <SelectWTN
          options={DAY_OPTIONS}
          className={styles.dobDay}
          name={valueKeys.day}
          disableErrorMessage
          placeholderText={t('form.inputDayPlaceholder')}
          onChangeCallback={val => {
            const fullDate = `${values[valueKeys.year]}-${values[valueKeys.month]}-${val}`
            setFieldValue(valueKeys.fullDate, fullDate)
          }}
          disabled={isDisabled}
          readOnly
          aria-label='day'
        />
        <SelectWTN
          options={MONTH_OPTIONS}
          className={styles.dobMonth}
          name={valueKeys.month}
          disableErrorMessage
          placeholderText={t('form.inputMonthPlaceholder')}
          onChangeCallback={val => {
            const fullDate = `${values[valueKeys.year]}-${val}-${values[valueKeys.day]}`
            setFieldValue(valueKeys.fullDate, fullDate)
          }}
          disabled={isDisabled}
          readOnly
          aria-label='month'
        />
        <SelectWTN
          options={YEAR_OPTIONS}
          className={styles.dobYear}
          name={valueKeys.year}
          disableErrorMessage
          placeholderText={t('form.inputYearPlaceholder')}
          onChangeCallback={val => {
            const fullDate = `${val}-${values[valueKeys.month]}-${values[valueKeys.day]}`
            setFieldValue(valueKeys.fullDate, fullDate)
          }}
          disabled={isDisabled}
          readOnly
          aria-label='year'
        />
      </fieldset>
      <ErrorMessage name={valueKeys.fullDate} component='div' className={formStyles.errorMessage} />
    </>
  )
}

export default DateSelectGroup
